import { ClientCard } from './ClientCard'
import type { Client } from '@/types/client'

interface ClientsGridProps {
  clients: Client[]
}

export function ClientsGrid({ clients }: ClientsGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {clients.map((client) => (
        <ClientCard key={client.id} client={client} />
      ))}
    </div>
  )
}
